import { AnchorHTMLAttributes, Component, DetailedHTMLProps, ReactNode } from 'react';

export default class ExternalLink extends Component<DetailedHTMLProps<AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement> & {
    href?: string,
    target: '_blank' | '_top' | '_parent' | '_self' | string,
    children: ReactNode
}> {

    static defaultProps = {
        target: '_blank'
    };

    render() {
        return (
            <a rel={this.props.target === '_blank' ? 'noopener noreferrer' : undefined} {...this.props}>
                { this.props.children }
            </a>
        );
    }

}
